module.exports = __webpack_public_path__ + "img/86.2cbefd9b.jpg";